import { useEffect, useState } from "react";
import {
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Theme,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useMutation } from "react-query";
import StarIcon from "@mui/icons-material/Star";
import DeleteIcon from "@mui/icons-material/Delete";

import { FilterGroup, setFavoriteGroup } from "../../services/Alert";
import { ActionTooltip } from "../../components/Tooltips";

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    "&:hover": {
      backgroundColor: theme.vars.palette.action.hover,
    },
  },
  selected: {
    backgroundColor: theme.vars.palette.action.selected,
  },
}));

export const FilterGroupListItem = ({
  group,
  onChange,
  onDelete,
  onSelect,
  selected,
}: {
  group: FilterGroup;
  onChange: () => void;
  onDelete: (group: FilterGroup) => void;
  onSelect: (group: FilterGroup) => void;
  selected: boolean;
}) => {
  const { classes } = useStyles();
  const [disabled, setDisabled] = useState(false);
  const mutation = useMutation<
    { favorite: boolean },
    Error,
    { groupId: number; favorite: boolean }
  >(({ groupId, favorite }) => setFavoriteGroup(groupId, favorite));

  const setFavorite = (group: FilterGroup) => {
    setDisabled(true);
    mutation.mutate(
      {
        groupId: group.id,
        favorite: !group.favorite,
      },
      { onSuccess: () => onChange() }
    );
  };

  /**
   * Remove the disabled state when list of groups has been updated
   */
  useEffect(() => {
    setDisabled(false);
  }, [group]);

  return (
    <ListItem
      key={group.id}
      className={`${classes.root} ${selected ? classes.selected : ""}`}
      secondaryAction={
        <IconButton
          aria-label="comments"
          disabled={group.readonly}
          edge="end"
          onClick={() => onDelete(group)}
          size="small"
        >
          <DeleteIcon />
        </IconButton>
      }
    >
      <ListItemIcon>
        <ActionTooltip title={group.favorite ? "FAVORITE_FILTER_DISPLAY" : ""}>
          <IconButton
            onClick={() => !group.favorite && setFavorite(group)}
            size="small"
            {...(group.favorite ? { color: "primary" } : {})}
            disabled={disabled}
          >
            <StarIcon />
          </IconButton>
        </ActionTooltip>
      </ListItemIcon>
      <ListItemText
        style={{ cursor: "pointer" }}
        primary={group.name}
        onClick={() => onSelect(group)}
      />
    </ListItem>
  );
};
